import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import RegistrationStatusType from './RegistrationStatusType';

export default class UserTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.email = null;
		/** @type {Date} */
		this.lastLoginTimestamp = null;
		/** @type {Date} */
		this.registrationTimestamp = null;
		/** @type {boolean} */
		this.registrationStatus = null;
		/** @type {NamedDto[]>} */
		this.roles = null;
		/** @type {Date} */
		this.created = null;
	}

	/**
	 * @typedef {Object} _UserTableDtoProps
	 * @property {string} email
	 * @property {Date} lastLoginTimestamp
	 * @property {Date} registrationTimestamp
	 * @property {boolean} registrationStatus
	 * @property {NamedDto[]} roles
	 * @property {Date} created
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _UserTableDtoProps} UserTableDtoProps
	 */
	/**
	 *
	 * @param {UserTableDtoProps} props
	 * @returns {UserTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.email = props.email;
		this.lastLoginTimestamp = props.lastLoginTimestamp != null ? new Date(props.lastLoginTimestamp) : null;
		this.registrationTimestamp = props.registrationTimestamp != null ? new Date(props.registrationTimestamp) : null;
		this.registrationStatus = props.registrationStatus;
		this.roles = props.roles != null ? props.roles.map(d => d) : [];
		this.created = props.created != null ? new Date(props.created) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'roles') {
			const s = _.isArray(this.roles) ? this.roles.filter(Boolean).map(r => { r = String(r).toLowerCase(); return r ? r.charAt(0).toUpperCase() + r.slice(1) : ''; }).filter(Boolean).join(', ') : '';
			return s || '-';
		}
		return super.getAsString(key);
	}

}